export const recoilKeys = {
  TIME_ZONE: 'timeZone',
  CLONE_INTERSECTION_ID: 'cloneIntersectionId',
  CLONE_INTERSECTION_DIALOG_STATE: 'cloneIntersectionDialogState',
  SELECTED_CROSSWALK: 'selectedCrosswalk',
  SELECTED_INTERSECTION_CROSSWALK: 'selectedIntersectionCrosswalk',
  SELECTED_LANE: 'selectedLane',
  SELECTED_MANEUVER: 'selectedManeuver',
  SELECTED_MANEUVER_LANE: 'selectedManeuverLane',
  SELECTED_INTERSECTION_MANEUVER: 'selectedIntersectionManeuver',
  SELECTED_INTERSECTION_MANEUVER_LANE: 'selectedIntersectionManeuverLane',
  SELECTED_MULTIMODAL: 'selectedMultimodal',
  SELECTED_INTEGRATION: 'selectedIntegration',
  SELECTED_DETECTOR: 'selectedDetector',
  SELECTED_DETECTOR_LANE: 'selectedDetectorLane',
  SELECTED_TRAFFIC_RESPONSIVE_PLAN: 'selectedTrafficResponsivePlan',
  SELECTED_TRAFFIC_RESPONSIVE_PLAN_ACTION: 'selectedTrafficResponsivePlanAction',
  SELECTED_HAR_TRANSMITTER: 'selectedHarTransmitter',
  SELECTED_TOLL_ROAD: 'selectedTollRoad',
  ASSOCIATED_ENTITIES: 'associatedEntities',
  SELECTED_MAP_DETAILS_ICON: 'selectedMapDetailsIcon',
  SELECTED_TRAVEL_TIME: 'selectedTravelTime',
  ICON_FORM_DATA: 'iconFormData',
};
